import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';

import { getEnterpriseConfig } from '#client/configs/enterprise';

export const ENTERPRISE_ID_QUERY = gql`
  query EnterpriseIdQuery {
    accountInfo {
      enterpriseId
    }
  }
`;

export function useEnterprise() {
  const { enterpriseId: tokenEnterpriseId, obo } = useAuthentication();

  const { data, loading } = useQuery(ENTERPRISE_ID_QUERY, {
    skip: !obo,
    noThrow: true,
  });

  const enterpriseId = obo ? data?.accountInfo?.enterpriseId : tokenEnterpriseId;
  const enterprise = getEnterpriseConfig(enterpriseId);

  return {
    enterprise,
    loading: obo ? loading : false,
  };
}
